<template>
<div>
    <vue-headful title="Areas of Work :: MeritEHS" />

    <h4 class="py-3 mb-4">
        <ol class="breadcrumb font-weight-bold m-0">
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/subcontractors`">
                    <i class="fa fa-id-badge"></i> Subcontractors
                </router-link>
            </li>
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/subcontractors/settings#prequalification`">
                    Settings - Areas of Work
                </router-link>
            </li>
            <li class="breadcrumb-item active">Edit</li>
        </ol>
    </h4>
    <template v-if="!done_loading">
        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
    </template>
    <template v-else>
        <div class="card mb-3">
            <div class="card-header">
                <h4>
                    Edit Areas of Work
                    <b-button size="sm" variant="success" @click="saveWorkAreas" :disabled="saving">
                        <template v-if="saving">
                            <i class="fa fa-spinner fa-pulse"></i> Saving
                        </template>
                        <template v-else>
                            Save
                        </template>
                    </b-button>
                </h4>
            </div>
            <div class="card-body">
                <b-row>
                    <b-col>
                        <div v-for="p in pcol1">
                            <b-form-checkbox v-model="p['status']" unchecked-value=0 value=1 plain>
                                {{ p.state_name }}
                            </b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col>
                        <div v-for="p in pcol2">
                            <b-form-checkbox v-model="p['status']" unchecked-value=0 value=1 plain>
                                {{ p.state_name }}
                            </b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col>
                        <div v-for="p in pcol3">
                            <b-form-checkbox v-model="p['status']" unchecked-value=0 value=1 plain>
                                {{ p.state_name }}
                            </b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </template>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            done_loading: false,
            saving: false,
            work_areas: [],
            count_per_column: 0,
            pcol1: [],
            pcol2: [],
            pcol3: [],
            errors: {},
        }
    },

    computed: {

    },

    methods: {
        getWorkAreas: function() {
            //Get the data
            this.$http
                .get('subcontractors/work-area-edit')
                .then(response => {
                    //Set all the data
                    this.work_areas = response.data;
                    this.count_per_column = Math.ceil(this.work_areas.length / 3);
                    if (this.count_per_column >= 4) {
                        var ix = 0;
                        for (var x = 0; x < this.count_per_column; ++x) {
                            this.pcol1.push(this.work_areas[ix]);
                            ix++;
                        }
                        for (var x = 0; x < this.count_per_column; ++x) {
                            this.pcol2.push(this.work_areas[ix]);
                            ix++;
                        }
                        for (var x = 0; x < this.count_per_column; ++x) {
                            if (this.work_areas[ix]) {
                                this.pcol3.push(this.work_areas[ix]);
                                ix++;
                            }
                        }
                    }
                })
                .catch(response => {
                    //How to handle the error
                })
                .then(() => {
                    //Set loading
                    this.done_loading = true;
                });
        },

        saveWorkAreas: function() {
            //Saving
            this.saving = true;

            var retval = [];

            this.pcol1.forEach((p) => {
                if (p['status'] == 1) {
                    retval.push(p['state_id']);
                }
            });
            this.pcol2.forEach((p) => {
                if (p['status'] == 1) {
                    retval.push(p['state_id']);
                }
            });
            this.pcol3.forEach((p) => {
                if (p['status'] == 1) {
                    retval.push(p['state_id']);
                }
            });

            this.$http
                .post('subcontractors/work-area-edit', {
                    'data': retval
                })
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Work Areas Saved');

                    this.$router.push('/subcontractors/settings#prequalification');
                })
                .catch(error => {
                    //Check for error
                    if (error.response.status === 422) {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
        },
    },

    mounted() {
        //Get the injuries
        this.getWorkAreas();
    }
}
</script>
